/* tslint:disable */
/* eslint-disable */
/**
 * Kinde Management API
 * Provides endpoints to manage your Kinde Businesses
 *
 * The version of the OpenAPI document: 1
 * Contact: support@kinde.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
/**
 * @export
 */
export var SetUserPasswordRequestHashingMethodEnum = {
    Bcrypt: 'bcrypt',
    Crypt: 'crypt',
    Md5: 'md5',
    Wordpress: 'wordpress'
};
/**
 * @export
 */
export var SetUserPasswordRequestSaltPositionEnum = {
    Prefix: 'prefix',
    Suffix: 'suffix'
};
/**
 * Check if a given object implements the SetUserPasswordRequest interface.
 */
export function instanceOfSetUserPasswordRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "hashedPassword" in value;
    return isInstance;
}
export function SetUserPasswordRequestFromJSON(json) {
    return SetUserPasswordRequestFromJSONTyped(json, false);
}
export function SetUserPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hashedPassword': json['hashed_password'],
        'hashingMethod': !exists(json, 'hashing_method') ? undefined : json['hashing_method'],
        'salt': !exists(json, 'salt') ? undefined : json['salt'],
        'saltPosition': !exists(json, 'salt_position') ? undefined : json['salt_position'],
        'isTemporaryPassword': !exists(json, 'is_temporary_password') ? undefined : json['is_temporary_password'],
    };
}
export function SetUserPasswordRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hashed_password': value.hashedPassword,
        'hashing_method': value.hashingMethod,
        'salt': value.salt,
        'salt_position': value.saltPosition,
        'is_temporary_password': value.isTemporaryPassword,
    };
}
